export const DEFAULT_LOGO_DIMENSIONS = Object.freeze({
  width: 1000,
  height: 450,
});

export const MAX_ORG_LOGO_DIMENSION = 512;
export const LOGO_COMPRESSION_QUALITY = 0.85;


